import { render } from "./Reportes.vue?vue&type=template&id=c96edc84&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"

import "./Reportes.vue?vue&type=style&index=0&id=c96edc84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96edc84"]])

export default __exports__